import React from "react";
import { ArchiveConfirmConsts } from "./constants";
import { CommonButtonTexts } from "../../../enums/ButtonAttributesEnums";
import InputField from "../../../reusable-components/TNInputField";
import { InputfieldTypes } from "../../../enums/InputFieldAttributesEnums";
import CustomerDatabaseService from "../../../services/customerDatabase.service";
import TNLoader from "../../../reusable-components/TNLoader";
import { message, Modal } from "antd";
import { useFormContext } from "react-hook-form";
import { useQueryClient } from "@tanstack/react-query";
import { QueryKeys } from "../../../constants/QueryKeys";

export interface ArchiveConfirmModalProps {
  isOpen?: boolean;
  handleClose: () => void;
  customerId?: string;
}

const ArchiveConfirmModal = ({
  isOpen,
  handleClose,
  customerId,
}: ArchiveConfirmModalProps) => {
  const {
    reset,
    getValues,
    control: { handleSubmit },
  } = useFormContext();
  const queryClient = useQueryClient();
  const {
    TITLE,
    MESSAGE,
    REASON_NAME,
    REASON_LABEL,
    REASON_PLACEHOLDER,
    ARCHIVE_SUCCESS,
    MODAL_WITH,
  } = ArchiveConfirmConsts;

  const { ArchiveCustomerProfile } = CustomerDatabaseService();

  const { mutateAsync: archiveCustomer, isPending: isArchivePending } =
    ArchiveCustomerProfile();

  const handleSubmitAction = async () => {
    const payload = {
      customerId: customerId,
      notes: getValues(REASON_NAME),
    };
    await archiveCustomer(payload, {
      onSuccess: () => {
        message.success(ARCHIVE_SUCCESS);
        queryClient.invalidateQueries([QueryKeys.GET_CUSTOMER_DATABASE_KEY]);
      },
    });
    handleClose();
  };

  const handleCancel = () => {
    reset();
    handleClose();
  };

  return (
    <>
      <TNLoader isLoading={isArchivePending} />
      <Modal
        title={TITLE}
        okText={CommonButtonTexts.CONFIRM}
        visible={isOpen}
        onCancel={handleCancel}
        onOk={handleSubmit(() => handleSubmitAction())}
        width={MODAL_WITH}
        loading={isArchivePending}
      >
        <div>{MESSAGE}</div>
        <InputField
          type={InputfieldTypes.TEXT_AREA}
          name={REASON_NAME}
          label={REASON_LABEL}
          maxLength={500}
          textAreaRows={6}
          noResize
          requiredField
          placeholder={REASON_PLACEHOLDER}
        />
      </Modal>
    </>
  );
};

export default ArchiveConfirmModal;
